import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import LocationModal from "./location/LocationModal";
import Search from "./search/Search";
import { useAuth } from "../../../context/AuthContext";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { fetchSuperCategories } from "../../../Redux/filters/slice";
import { RootState } from "../../../store";
import VacationAds from "./Allads/VacationAds";
import AllAds from "./Allads/AllAds";

const getCategoryBgClass = (tabName: string) => {
  const name = tabName.toLowerCase();
  if (name === "all") return "all-bg";
  if (name.includes("fashion") || name.includes("clothing") || name.includes("apparel") || name === "men" || name === "women") return "vacation-bg";
  if (name.includes("kids") || name.includes("toy")) return "kids-bg";
  if (name.includes("mobile") || name.includes("phone")) return "electronic-bg";
  if (name.includes("electronic")) return "beauty-bg";
  if (name.includes("beauty") || name.includes("personal") || name.includes("cosmetic")) return "decor-bg";
  if (name.includes("home") || name.includes("kitchen")) return "gifting-bg";
  if (name.includes("appliance")) return "imported-bg";
  if (name.includes("furniture")) return "furniture-bg";
  return "all-bg";
};

const getCategoryIconClass = (tabName: string) => {
  const name = tabName.toLowerCase();
  if (name === "all") return "fi fi-ts-grocery-basket";
  if (name.includes("fashion") || name.includes("clothing") || name.includes("apparel") || name === "men" || name === "women") return "fi fi-ts-tshirt";
  if (name.includes("kids") || name.includes("toy")) return "fi fi-ts-teddy-bear";
  if (name.includes("mobile") || name.includes("phone")) return "fi fi-ts-mobile-notch";
  if (name.includes("electronic")) return "fi fi-ts-computer-speaker";
  if (name.includes("beauty") || name.includes("personal") || name.includes("cosmetic")) return "fi fi-ts-blush";
  if (name.includes("home") || name.includes("kitchen")) return "fi fi-ts-light-ceiling";
  if (name.includes("appliance")) return "fi fi-ts-washer";
  if (name.includes("furniture")) return "fi fi-ts-couch";
  return "fi fi-ts-grocery-basket";
};

const Navbar = () => {
  const navigate = useNavigate();
  const { isAuthenticated , user } = useAuth();
  const dispatch = useAppDispatch();
  const { location } = useAppSelector((state) => state.deliveryLocation);
  const { superCategories } = useAppSelector((state: RootState) => state.filters);

  const [activeTab, setActiveTab] = useState("all");

  useEffect(() => {
    if (superCategories.data.length === 0 && !superCategories.loading) {
      dispatch(
        fetchSuperCategories({
          categoryTypeName: "Ecommerce",
          showOnWebsite: true,
          showOnHomepage: true,
        }),
      );
    }
  }, [dispatch, superCategories.data.length, superCategories.loading]);

  const mobileLocationText = location?.displayName
    ? location.displayName.length > 35
      ? `${location.displayName.slice(0, 35)}...`
      : location.displayName
    : "Set your location";
  return (
    <>
      <div className=" display-max">
        <nav className="navbar navbar-expand-md Navbar-custom z-index-3">
          <div className="container-fluid w-100 align-items-baseline">
            <div className=" w-100">
              <div>
                <Search />
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div className=" display-mini display-mob">
        <div className="mb-2">
          <div
            className={`card-image-2 detail-card-header shadow-lg min-height-350 ${getCategoryBgClass(activeTab)}`}>
            <div className="position-absolute w-100 px-3 end-1 mt-2 p-1">
              <div className=" d-flex justify-content-between align-items-center">
                <div className=" text-start lh-sm">
                  <div>
                    <b className=" text-black fw-boldest text-2xl">
                     {user?.fullName}
                    </b>{" "}
                  </div>
                </div>
                <div className=" d-flex gap-2">
                  <div className="icon icon-shape-mini d-flex justify-content-center align-items-center bg-white rounded-circle">
                    <img src="../../assets/img/wallet.png" height={20} className=" mt-n0" alt="" />
                  </div>
                  <div className="icon icon-shape-mini d-flex justify-content-center align-items-center bg-white rounded-circle">
                    <img src="../../assets/img/bell.png" height={20} className=" opacity-6 mt-n0" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div className="nav-text-address w-100 px-2 mx-auto cursor-pointer"
              data-bs-toggle="offcanvas" data-bs-target="#offcanvasAddress" aria-controls="offcanvasAddress">
              <div className=" bg-white border-radius-lg px-2">
                <div className="address-truncate-mini">
                  <b className=" text-black fw-bold text-xs">
                    <i className="fi fi-rr-house-building me-1"></i>{" "}
                    {mobileLocationText}
                  </b>
                </div>
              </div>
            </div>
            <div className="nav-text container-fluid px-2">
              <div className=" d-flex justify-content-center align-items-center mx-auto w-100 mb-1">
                <Search />
              </div>
              <ul
                className="nav nav-tabs text-nowrap mt-2 d-flex justify-content-start gap-03 px-2 align-items-center overflow-sides flex-nowrap"
                id="myTab"
                role="tablist"
              >
                <li className="nav-item lh-sm" role="presentation">
                  <button
                    className={`nav-link ${activeTab === "all" ? "active" : ""} text-black text-xxs`}
                    id="all-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#all"
                    type="button"
                    role="tab"
                    aria-controls="all"
                    aria-selected={activeTab === "all"}
                    onClick={() => setActiveTab("all")}
                  >
                    <div>
                      <i className="fi fi-ts-grocery-basket text-black text-2xl"></i>
                    </div>
                    All
                  </button>
                </li>
                <li className="nav-item lh-sm" role="presentation">
                  <button
                    className={`nav-link ${activeTab === "referal" ? "active" : ""} text-black text-xxs`}
                    id="referal-tab"
                    type="button"
                    role="tab"
                    aria-controls="referal"
                    aria-selected={activeTab === "referal"}
                    onClick={() => {
                      setActiveTab("referal");
                      navigate("/RefProducts");
                    }}
                  >
                    <div>
                      <i className="fi fi-ts-grocery-basket text-black text-2xl"></i>
                    </div>
                    Referals
                  </button>
                </li>
                {superCategories.data.map((category) => (
                  <li className="nav-item lh-sm" role="presentation" key={category._id}>
                    <button
                      className={`nav-link ${activeTab === category.name ? "active" : ""} text-black text-xxs`}
                      id={`${category.slug}-tab`}
                      data-bs-toggle="tab"
                      data-bs-target={`#${category.slug}`}
                      type="button"
                      role="tab"
                      aria-controls={category.slug}
                      aria-selected={activeTab === category.name}
                      onClick={() => setActiveTab(category.name)}
                    >
                      <div>
                        <i className={`${getCategoryIconClass(category.name)} text-black text-2xl`}></i>
                      </div>
                      {category.name.substring(0, 8)}
                    </button>
                  </li>
                ))}
              </ul>
              <hr className=" horizontal black mt-1" />
            </div>
            <div className="tab-content">
              {activeTab.toLowerCase().includes("fashion") ||
              activeTab.toLowerCase().includes("mobile") ? (
                <div>
                  <VacationAds />
                </div>
              ) : (
                <div>
                  <AllAds />
                </div>
              )}
            </div>{" "}
          </div>
        </div>
      </div>
      <LocationModal />
    </>
  );
};

export default Navbar;
